module.exports = __webpack_public_path__ + "static/media/feature-vip1.2046d871.png";